import cn from "classnames";
import React, { forwardRef, useEffect, useMemo, useState, } from "react";
import { AuctionItemStatus, } from "../auctions-list-page/contracts";
import { BidSelector } from "../components/auctionLots/BidModule";
import { getAvailableMaxBids } from "../components/auctionLots/getAvailableMaxBids";
import getAuctionHub from "../getAuctionHub";
import { useLiveAuction } from "../live-auction/useLiveAuction";
import formatPrice from "../utils/formatPrice";
import styles from "./AuctionItem.module.scss";
function AuctionHallItem({ item: initialItem, strings, auctionUrl, imageBaseUrl, isCurrent, canBid, }, ref) {
    const [item, setItem] = useState(initialItem);
    useEffect(() => setItem(initialItem), [initialItem]);
    const liveAuction = useLiveAuction(initialItem.auctionId);
    const kind = isCurrent
        ? "podium"
        : item.status == AuctionItemStatus.Sold ||
            item.status == AuctionItemStatus.SoldConfirmed ||
            item.status == AuctionItemStatus.NotSold
            ? "sold"
            : "active";
    const availableMaxBids = useMemo(() => {
        var _a;
        return getAvailableMaxBids(item.currentBidPrice, item.bidsCount, (_a = item.customerBid) === null || _a === void 0 ? void 0 : _a.maxBidPrice);
    }, [item.currentBidPrice]);
    useEffect(() => {
        const unwatchPromise = getAuctionHub().then((hub) => hub === null || hub === void 0 ? void 0 : hub.watchLot(item.id, async (bidPlaced) => {
            setItem({ ...item, ...bidPlaced });
        }));
        return () => {
            unwatchPromise.then((unwatch) => {
                if (unwatch)
                    unwatch();
            });
        };
    }, []);
    const isSold = kind === "sold";
    const isPodium = kind === "podium";
    const isUpcoming = kind === "active";
    const isBiddable = kind == "active" && canBid;
    return (React.createElement("div", { className: cn(styles.item, styles[kind]), ref: ref },
        React.createElement("img", { srcSet: `
                    ${imageBaseUrl}/img/${item.id}/${item.mainImageFileId}?size=md 840w,
                    ${imageBaseUrl}/img/${item.id}/${item.mainImageFileId}?size=sm 70w
                `, sizes: `
                    (max-width: 1200px) 840px,
                    70px
                `, className: styles.thumbnail }),
        React.createElement("a", { href: `${auctionUrl}archive/lot/${item.id}` }, item.number),
        isSold && (React.createElement("span", { className: styles.sold }, strings.lotStatuses[AuctionItemStatus[item.status]])),
        isUpcoming && (React.createElement("span", { className: styles.bidsCount }, strings.bidsNumber.replace("{number}", item.bidsCount.toString()))),
        isPodium && (React.createElement("span", { className: styles.onPodium }, strings.onPodium)),
        isBiddable && liveAuction.ready ? (React.createElement(BidSelector, { isLiveAuction: liveAuction.isLive, strings: strings, availableMaxBids: availableMaxBids, currentBidPrice: item.currentBidPrice, lotId: item.id, bidsCount: item.bidsCount, onBid: () => Promise.resolve() })) : (React.createElement("span", null)),
        React.createElement("span", { className: cn(styles.price, styles.highlighted) }, formatPrice(item.currentBidPrice))));
}
export default forwardRef((props, ref) => AuctionHallItem(props, ref));
